<template>
  <div class="content">
    <div class="row mb-10">
      <div class="col-md-2">
        <div>
          <span class="emoji">{{ clockEmoji }}</span>
          <span class="time-font ml-10"><strong>{{ dateTime }}</strong> <small class="text-muted est-font"> (EST)</small> </span>
        </div>
      </div>
      <div class="col-md-8 d-flex align-items-center justify-content-center">
        <h4 class="fw-600 mt-15">Shift Availability</h4>
      </div>
      <div class="col-md-2 d-flex align-items-center justify-content-end">
        <template>
          <div v-if="attendanceStatus.status === 'shift out'" class="dropdown mr-10">
            <button class="btn btn-secondary btn-outline-secondary dropdown-toggle btn-sm" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Change Mode
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <a v-if="attendanceStatus.status==='shift out' && currentMode !== 'active'" @click="mode('active')" class="dropdown-item" href="#">Active</a>
              <a v-if="currentMode !== 'engineering'" @click="mode('engineering')" class="dropdown-item" href="#">Engineering</a>
              <a v-if="currentMode !== 'meeting'" @click="mode('meeting')" class="dropdown-item" href="#">Meeting</a>
              <a v-if="currentMode !== 'performance'" @click="mode('performance')" class="dropdown-item" href="#">Performance</a>
              <a v-if="currentMode !== 'other'" @click="mode('other')" class="dropdown-item" href="#">Other</a>
            </div>
          </div>
<!--          <button v-if="attendanceStatus.status==='shift out' && !isOffSupport"  data-toggle="modal"  @click="mode('offSupport')" type="button"  class="btn btn-secondary btn-outline-default btn-sm left mr-10" :disabled="disabled">-->
<!--            Change Mode<i v-if="modeLoading" class="fa fa-spin fa-spinner"></i>-->
<!--          </button>-->
<!--          <button v-if="attendanceStatus.status==='shift out' && isOffSupport"  data-toggle="modal"  @click="mode('active')" type="button"  class="btn btn-success btn-outline-success btn-sm left mr-10" :disabled="disabled">-->
<!--            Active Mode <i v-if="modeLoading" class="fa fa-spin fa-spinner"></i>-->
<!--          </button>-->
        </template>
        <button  v-if="attendanceStatus.status==='shift out' && !onBreak"  data-toggle="modal"  @click="fixModal" type="button"  class="btn btn-info btn-outline-info btn-sm left " :disabled="disabled">
            Break <i v-if='adminAttendanceLoading' :class="{'fa fa-refresh': true, 'fa-spin': adminAttendanceLoading}"></i>
         </button>
         <button  v-if="attendanceStatus.status==='shift out' && onBreak"  @click="endBreak" type="button"  class="btn btn-warning btn-outline-warning btn-sm left" :disabled="disabled">
            End Break  <i v-if='adminAttendanceLoading' :class="{'fa fa-refresh': true, 'fa-spin': adminAttendanceLoading}"></i>
         </button>
        <button v-if="!attendanceLoading" type="button" :class="`btn ${attendanceStatus.status === 'shift in'? 'btn-success btn-outline-success' : 'btn-danger btn-outline-danger'} btn-sm left ml-10`" @click="clockInOut(attendanceStatus.status)" :disabled="disabled || onBreak">
           {{ attendanceStatus.status }}     <i v-if='adminAttendanceLoading' :class="{'fa fa-refresh': true, 'fa-spin': adminAttendanceLoading}"></i>
         </button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <h6 class="hero-heading ml-10 mb-4">Support Team</h6>
        <div
            class="card d-flex flex-direction-row justify-content-between"
            style="background: linear-gradient(135deg, #9BCD9B 0%, #D0F0C0 100%); border-radius: 20px"
        >
          <div
              class="d-flex flex-wrap mt-8 ml-8 mb-8 mr-8"
              :style="{ width: getWidths().onDutyWidth }"
              :class="{ 'mt-40': onDutyAdmins.length === 0 }"
          >
            <img
                v-for="(row, index) in onDutyAdmins"
                :id="row.uid"
                data-toggle="tooltip"
                data-placement="top"
                data-html="true"
                :key="row.firstName + 'break'"
                width="30px"
                class="adminImage make-cursor-pointer mb-3"
                :title="`${row.firstName} is available`"
                :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=200`"
            >
          </div>

          <div
              class="d-flex flex-wrap mt-8 ml-8 mb-8 mr-8 justify-content-end"
              :style="{ width: getWidths().upcomingWidth }"
              :class="{ 'mt-40': upComingHeroes.length === 0 }"
          >
            <img
                v-for="(row, index) in upComingHeroes"
                :id="row.uid"
                data-toggle="tooltip"
                data-placement="top"
                data-html="true"
                :key="row.firstName + 'break'"
                width="30px"
                class="adminImage grayscale make-cursor-pointer mb-3"
                :title="`${row.diffInMinutes >= 0 ? `${row.firstName} will be joining in ${row.hoursLeft} hour(s) and ${row.minutesLeft} minute(s).` : `${row.firstName} is late — expected clock-in was at ${row.todayShift.shiftIn} EST.`}`"
                :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=200`"
            >
          </div>
        </div>
<!--        <div class="card d-flex justify-content-between flex-direction-row" style="background: linear-gradient(135deg, #9BCD9B 0%, #D0F0C0 100%); border-radius: 20px">-->
<!--          <div class="mt-8 ml-8 mb-8 mr-8" :style="getWidth(upComingHeroes)" :class="{'mt-40' : onDutyAdmins.length === 0}">-->
<!--            <img v-for="(row, index) in onDutyAdmins" :id='row.uid' data-toggle="tooltip" data-placement="top" data-html="true" :key="row.firstName+'break'" width="30px" class="adminImage make-cursor-pointer mb-3" :title="`${row.firstName} is available`" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=200`">-->
<!--          </div>-->
<!--          <div class=" mt-8 ml-8 mb-8 mr-8 d-flex flex-wrap justify-content-end" :style="upComingHeroes.length >= 3 ? 'width: 20%;' : (upComingHeroes.length >= 1 ? 'width: 10%;' : 'width: 0%;')" :class="{'mt-40' : upComingHeroes.length === 0}">-->
<!--            <img v-for="(row, index) in upComingHeroes"  :id='row.uid' data-toggle="tooltip" data-placement="top" data-html="true" :key="row.firstName+'break'" width="30px" class="adminImage grayscale make-cursor-pointer mb-3" :title="`${row.firstName} will be joining in ${row.hoursLeft} hour(s) and ${row.minutesLeft} minute(s)`" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=200`">-->

<!--          </div>-->
<!--        </div>-->
      </div>
      <div class="col-md-4">
        <h6 class="hero-heading ml-10 mb-4">Client Success Team</h6>
        <div class="card d-flex justify-content-between flex-direction-row " style="background: linear-gradient(135deg, #fbc2eb 0%, #a6c1ee 100%); border-radius: 20px">
          <div class="mt-8 ml-8 mb-8 mr-8" :style="getWidth(upComingSalesHeroes)" :class="{'mt-40' : onDutySalesAdmins.length === 0}">
            <img v-for="(row, index) in onDutySalesAdmins" :id='row.uid' data-toggle="tooltip" data-placement="top" data-html="true" :key="row.firstName+'break'" width="30px" class="adminImage make-cursor-pointer mb-3" :title="`${row.firstName} is available`" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=200`">
          </div>
          <div class=" mt-8 ml-8 mb-8 mr-8 d-flex justify-content-end" :style="upComingSalesHeroes.length >= 3 ? 'width: 20%;' : (upComingSalesHeroes.length >= 1 ? 'width: 10%;' : 'width: 0%;')" :class="{'mt-40' : upComingSalesHeroes.length === 0}">
            <img v-for="(row, index) in upComingSalesHeroes"  :id='row.uid' data-toggle="tooltip" data-placement="top" data-html="true" :key="row.firstName+'break'" width="30px" class="adminImage grayscale make-cursor-pointer mb-3" :title="row.diffInMinutes >= 0 ? `${row.firstName} will be joining in ${row.hoursLeft} hour(s) and ${row.minutesLeft} minute(s)` : `${row.firstName} is late — expected clock-in was at ${row.todayShift.shiftIn} EST.`" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=200`">

          </div>
        </div>
      </div>
      <div class="col-md-4">
        <h6 class="hero-heading ml-10 mb-4">Development Team</h6>
        <div class="card d-flex justify-content-between flex-direction-row " style="background: linear-gradient(135deg, #f7b7a3 0%, #f4d03f 100%); border-radius: 20px">
          <div class="mt-8 ml-8 mb-8 mr-8" :style="getWidth(upComingDevHeroes)" :class="{'mt-40' : devAdmins.length === 0 }">
            <img v-for="(row, index) in devAdmins" :id='row.uid' data-toggle="tooltip" data-placement="top" data-html="true" :key="row.firstName+'break'" width="30px" class="adminImage make-cursor-pointer mb-3" :title="`${row.firstName} is available`" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=200`">
          </div>
          <div class=" mt-8 ml-8 mb-8 mr-8 d-flex justify-content-end" :style="upComingDevHeroes.length >= 3 ? 'width: 20%;' : (upComingDevHeroes.length >= 1 ? 'width: 10%;' : 'width: 0%;')" :class="{'mt-40' : upComingDevHeroes.length === 0}">
            <img v-for="(row, index) in upComingDevHeroes"  :id='row.uid' data-toggle="tooltip" data-placement="top" data-html="true" :key="row.firstName+'break'" width="30px" class="adminImage grayscale make-cursor-pointer mb-3" :title="`${row.diffInMinutes >= 0 ? `${row.firstName} will be joining in ${row.hoursLeft} hour(s) and ${row.minutesLeft} minute(s).` : `${row.firstName} is late — expected clock-in was at ${row.todayShift.shiftIn} EST.`}`" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=200`">

          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="d-flex align-items-center">
          <h6 class="hero-heading ml-10 mb-4">On Break</h6>
<!--          <span @mouseover="getTitle(true, 'Apply Break', 'apply_break')" @mouseleave="getTitle(false)" id="apply_break" v-if="attendanceStatus.status==='shift out' && !isOnBreak"  @click="fixModal()"><i class="fa fa-coffee ml-5 make-cursor-pointer"></i></span>-->
<!--          <span @mouseover="getTitle(true, 'End Break', 'end_break')" @mouseleave="getTitle(false)" id="end_break" @click="endBreak" class="make-cursor-pointer ml-5" v-else-if="attendanceStatus.status==='shift out' && isOnBreak" ><i class="fa fa-arrow-circle-left"></i></span>-->
        </div>
        <div
            class="card"
            :class="{'pt-15 pb-15': !onBreakSupportAdmins.length && !onBreakSalesAdmins.length && !onBreakDevAdmins.length}"
            style="background:linear-gradient( to right,#9BCD9B 0%, #D0F0C0 33.33%,#fbc2eb 33.33%, #a6c1ee 66.66%,#f7b7a3 66.66%, #f4d03f 100%);
         border-radius: 20px; display:flex; flex-direction: row !important;"
        >
          <!-- Section 1 - Green -->
          <div class=" mt-8 ml-8 mb-8 mr-8" style="width: 33.33%;">
            <img
                data-toggle="tooltip" data-placement="top" data-html="true"
                :title="`${getBreakText(admin, 'break')}`"
                v-for="admin in onBreakSupportAdmins"
                :key="admin.email"
                :src="`https://www.gravatar.com/avatar/${emailHashGravatar(admin.email)}?s=200`"
                class="adminImage make-cursor-pointer mb-2"
                width="30px"
            />
          </div>

          <!-- Section 2 - Orange -->
          <div class=" mt-8 ml-8 mb-8 mr-8" style="width: 33.33%;">
            <img
                data-toggle="tooltip" data-placement="top" data-html="true"
                :title="`${getBreakText(admin, 'break')}`"
                v-for="admin in onBreakSalesAdmins"
                :key="admin.email"
                :src="`https://www.gravatar.com/avatar/${emailHashGravatar(admin.email)}?s=200`"
                class="adminImage make-cursor-pointer mb-2"
                width="30px"
            />
          </div>

          <!-- Section 3 - Blue -->
          <div class=" mt-8 ml-8 mb-8 mr-8" style="width: 33.33%;">
            <img
                data-toggle="tooltip" data-placement="top" data-html="true"
                :title="`${getBreakText(admin, 'break')}`"
                v-for="admin in onBreakDevAdmins"
                :key="admin.email"
                :src="`https://www.gravatar.com/avatar/${emailHashGravatar(admin.email)}?s=200`"
                class="adminImage make-cursor-pointer mb-2"
                width="30px"
            />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="d-flex align-items-center">
          <h6 style="width: 32%" class="hero-heading fs-12 ml-10 mb-4">Perf <i title="Use this mode when you are a part of performance team and actively working on 'performance/optimization' related tasks." data-toggle="tooltip" data-placement="top" class="fa fa-info-circle make-cursor-pointer"></i></h6>
          <h6 style="width: 33%" class="hero-heading fs-12 mb-4">Eng <i title="Use this mode when you are a part of engineering team and actively working on an engineering-related tasks." data-toggle="tooltip" data-placement="top" class="fa fa-info-circle make-cursor-pointer"></i></h6>
          <h6 style="width: 33%"  class="hero-heading fs-12 mb-4">Meeting <i title="Use this mode when you are not working on customer support desk but focusing on your meetings/calls." data-toggle="tooltip" data-placement="top" class="fa fa-info-circle make-cursor-pointer"></i></h6>
          <h6 style="width: 33%"  class="hero-heading fs-12 mb-4">Other <i title="Use this mode if the reason you're busy doesn't fall under Performance, Engineering, or Meeting Mode." data-toggle="tooltip" data-placement="top" class="fa fa-info-circle make-cursor-pointer"></i></h6>
<!--          <i data-toggle="tooltip" data-placement="top" title="Use this when you're working but not actively handling support. This includes meetings, offsite events, or performance-related tasks." class="fa fa-info-circle ml-5 mb-4 make-cursor-pointer"></i>-->
        </div>
        <div
            class="card"
            :class="{'pt-15 pb-15': !onPerfMode.length && !onMeetingMode.length && !onEngMode.length && !otherMode.length}"
            style="background:linear-gradient( to right,#d3d3d3 0%, #f1f1f1 25%,#d3d3d3 25%, #f1f1f1 50%,#d3d3d3 50%, #f1f1f1 75%,#d3d3d3 75%, #f1f1f1 100%);
         border-radius: 20px; display:flex; flex-direction: row !important;">
          <div class="mt-8 ml-8 mb-8 mr-8" style="width: 25%">
            <img
                data-toggle="tooltip" data-placement="top" data-html="true"
                :title="`${admin.firstName} is on ${admin.breaks[admin.breaks.length - 1].type} mode.`"
                v-for="admin in onPerfMode"
                :key="admin.email"
                :src="`https://www.gravatar.com/avatar/${emailHashGravatar(admin.email)}?s=200`"
                class="adminImage make-cursor-pointer mb-2"
                width="30px"
            />
          </div><div class="mt-8 ml-8 mb-8 mr-8" style="width: 25%">
            <img
                data-toggle="tooltip" data-placement="top" data-html="true"
                :title="`${admin.firstName} is on ${admin.breaks[admin.breaks.length - 1].type} mode.`"
                v-for="admin in onEngMode"
                :key="admin.email"
                :src="`https://www.gravatar.com/avatar/${emailHashGravatar(admin.email)}?s=200`"
                class="adminImage make-cursor-pointer mb-2"
                width="30px"
            />
          </div><div class="mt-8 ml-8 mb-8 mr-8" style="width: 25%">
            <img
                data-toggle="tooltip" data-placement="top" data-html="true"
                :title="`${admin.firstName} is on ${admin.breaks[admin.breaks.length - 1].type} mode.`"
                v-for="admin in onMeetingMode"
                :key="admin.email"
                :src="`https://www.gravatar.com/avatar/${emailHashGravatar(admin.email)}?s=200`"
                class="adminImage make-cursor-pointer mb-2"
                width="30px"
            />
          </div>
          <div class="mt-8 ml-8 mb-8 mr-8" style="width: 25%">
            <img
                data-toggle="tooltip" data-placement="top" data-html="true"
                :title="`${admin.firstName} is on ${admin.breaks[admin.breaks.length - 1].type} mode.`"
                v-for="admin in otherMode"
                :key="admin.email"
                :src="`https://www.gravatar.com/avatar/${emailHashGravatar(admin.email)}?s=200`"
                class="adminImage make-cursor-pointer mb-2"
                width="30px"
            />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <h6 class="hero-heading ml-10 mb-4">On Leave</h6>
        <div
            class="card"
            :class="{'pt-15 pb-15': !supportOnLeave.length && !salesOnLeave.length && !devsOnLeave.length}"
            style="background:linear-gradient( to right,#9BCD9B 0%, #D0F0C0 33.33%,#fbc2eb 33.33%, #a6c1ee 66.66%,#f7b7a3 66.66%, #f4d03f 100%);
         border-radius: 20px; display:flex; flex-direction: row !important;"
        >
          <!-- Section 1 - Green -->
          <div class=" mt-8 ml-8 mb-8 mr-8" style="width: 33.33%;">
            <img
                data-toggle="tooltip" data-placement="top" data-html="true"
                :title="`${getBreakText(admin, 'leave')}`"
                v-for="admin in supportOnLeave"
                :key="admin.email"
                :src="`https://www.gravatar.com/avatar/${emailHashGravatar(admin.email)}?s=200`"
                class="adminImage make-cursor-pointer mb-2"
                width="30px"
            />
          </div>

          <!-- Section 2 - Orange -->
          <div class=" mt-8 ml-8 mb-8 mr-8" style="width: 33.33%;">
            <img
                data-toggle="tooltip" data-placement="top" data-html="true"
                :title="`${getBreakText(admin, 'leave')}`"
                v-for="admin in salesOnLeave"
                :key="admin.email"
                :src="`https://www.gravatar.com/avatar/${emailHashGravatar(admin.email)}?s=200`"
                class="adminImage make-cursor-pointer mb-2"
                width="30px"
            />
          </div>

          <!-- Section 3 - Blue -->
          <div class=" mt-8 ml-8 mb-8 mr-8" style="width: 33.33%;">
            <img
                data-toggle="tooltip" data-placement="top" data-html="true"
                :title="`${getBreakText(admin, 'leave')}`"
                v-for="admin in devsOnLeave"
                :key="admin.email"
                :src="`https://www.gravatar.com/avatar/${emailHashGravatar(admin.email)}?s=200`"
                class="adminImage make-cursor-pointer mb-2"
                width="30px"
            />
          </div>
        </div>
      </div>
      <div class="col-md-2"></div>
    </div>
    <div class="row">
<!--      <div class="col-lg-4 col-md-6 col-sm-6">-->
<!--        <div v-if="(onDutyAdmins && onDutyAdmins.length) || (onBreakAdmins && onBreakAdmins.length)">-->
<!--          <h6 class="hero-heading ml-10 mb-4">Today's Heroes</h6>-->
<!--          <div class="card top-cards">-->
<!--            <div class="row ml-0 mr-0 card-content mb-0">-->
<!--              <div :class="getColumnClass" class="pr-5 pt-15 pb-15" id="onDutyAdmin" style="background: linear-gradient(to right, #58fb9b3d,  #58fb9b3d); border-top-left-radius: 21px; border-bottom-left-radius: 21px" :style="!onBreakAdmins.length && !upComingHeroes.length ? 'border-top-right-radius: 21px; border-bottom-right-radius: 21px' : ''">-->
<!--                <span v-for="(row, index) in onDutyAdmins" :key="index">-->
<!--                  <img data-toggle="tooltip" data-placement="top" data-html="true" class="adminImage make-cursor-pointer mb-3" width="20px" :title="`${row.firstName} is online`" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=200`">-->
<!--                </span>-->
<!--              </div>-->
<!--              <div v-if="onBreakAdmins && onBreakAdmins.length > 0" :class="getColForBreakAdmins" class="text-center pt-15 pb-15 pl-0 pr-0" style="background: linear-gradient(to right, #fbc65869,  #fbc65869)" :style="!upComingHeroes.length ? 'border-top-right-radius: 21px; border-bottom-right-radius: 21px' : ''">-->
<!--                <span v-for="(row, index) in onBreakAdmins" :key="index+'break'">-->
<!--                  <img :id='row.uid' data-toggle="tooltip" data-placement="top" data-html="true" :key="row.firstName+'break'" class="adminImage make-cursor-pointer mb-3" width="20px" :title="`${row.firstName} is on break`" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=200`">-->
<!--                </span>-->
<!--              </div>-->
<!--              <div v-if="upComingHeroes && upComingHeroes.length > 0" :class="getColForUpcomingAdmins" class="text-center pt-15 pb-15 pl-8 pr-3" style="background: linear-gradient(to right, #DEE2ED,  #DEE2ED);border-top-right-radius: 21px; border-bottom-right-radius: 21px">-->
<!--                <span v-for="(row, index) in upComingHeroes" :key="index+'break'">-->
<!--                  <img :id='row.uid' data-toggle="tooltip" data-placement="top" data-html="true" :key="row.firstName+'break'" class="adminImage make-cursor-pointer mb-3" width="20px" :title="`${row.firstName} will be joining in ${row.hoursLeft} hour(s) and ${row.minutesLeft} minute(s)`" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=200`">-->
<!--                </span>-->
<!--              </div>-->



<!--              &lt;!&ndash;              <div class="ml-10 pt-15 pb-15 mr-10">&ndash;&gt;-->
<!--              &lt;!&ndash;                <span>&ndash;&gt;-->
<!--              &lt;!&ndash;                  <span v-for="(row, index) in activeAdmins" :key="index">&ndash;&gt;-->
<!--              &lt;!&ndash;                  <img data-toggle="tooltip" data-placement="top" data-html="true" class="adminImage make-cursor-pointer" width="20px" :title="row.firstName" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=200`">&ndash;&gt;-->
<!--              &lt;!&ndash;                  <div v-if="index===13" class="mb-10"></div>&ndash;&gt;-->
<!--              &lt;!&ndash;                </span>&ndash;&gt;-->
<!--              &lt;!&ndash;                </span>&ndash;&gt;-->
<!--              &lt;!&ndash;                <span>&ndash;&gt;-->
<!--              &lt;!&ndash;                  <span v-for="(row, index) in onBreakAdmins" :key="index+'break'">&ndash;&gt;-->
<!--              &lt;!&ndash;                  <img data-toggle="tooltip" data-placement="top" data-html="true" class="adminImage make-cursor-pointer" width="20px" :title="row.firstName" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=200`">&ndash;&gt;-->
<!--              &lt;!&ndash;                  <div v-if="index===13" class="mb-10"  ></div>&ndash;&gt;-->
<!--              &lt;!&ndash;                </span>&ndash;&gt;-->
<!--              &lt;!&ndash;                </span>&ndash;&gt;-->
<!--              &lt;!&ndash;              </div>&ndash;&gt;-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

      <!--      <div class="col-lg-2 col-md-1 col-sm-6 p-0">-->
      <!--        <div v-if="(upComingHeroes && upComingHeroes.length)">-->
      <!--          <h6 class="hero-heading ml-10 mb-4">Upcoming heroes</h6>-->
      <!--          <div :style="`background: linear-gradient(to right, #DEE2ED 0%, #DEE2ED 100%, #fbc65869 75%, #fbc65869 100%)`"  class="card top-cards">-->
      <!--            <div class="row ml-5 pt-15 pb-15 mr-5 card-content mb-0">-->
      <!--              <div  class="col-md-12 pr-0">-->
      <!--                <span v-for="(row, index) in upComingHeroes" :key="index">-->
      <!--                  <img data-toggle="tooltip" data-placement="top" data-html="true" class="adminImage make-cursor-pointer mb-3" width="20px"  :title="`${row.firstName} will be joining in ${row.hoursLeft} hours and ${row.minutesLeft} minutes`" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=200`">-->
      <!--                </span>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
<!--      <div class="d-flex col-lg-5 col-md-5 col-sm-6 d-flex justify-content-around align-items-start">-->
<!--        <div class="pt-20">-->
<!--          <span class='text-capitalize ' style="font-size: 30px"><strong>Welcome {{ user.firstName }}</strong></span>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="d-flex justify-content-end align-items-center col-sm-12 col-md-3 col-lg-3 mt-2">-->
<!--        <div class="card-transparent">-->
<!--          <div class="card-head">-->
<!--            <span class="card-category">-->
<!--              <div class="d-flex">-->
<!--                 <button  v-if="attendanceStatus.status==='shift out' && !isOnBreak"  data-toggle="modal"  @click="fixModal" data-target="#getBreakModal" type="button"  class="btn btn-info  btn-sm left" :disabled="disabled">-->
<!--                    Break <i v-if='adminAttendanceLoading' :class="{'fa fa-refresh': true, 'fa-spin': adminAttendanceLoading}"></i>-->
<!--                 </button>-->
<!--                 <button  v-if="attendanceStatus.status==='shift out' && isOnBreak"  @click="endBreak" type="button"  class="btn btn-warning btn-sm left" :disabled="disabled">-->
<!--                    End Break  <i v-if='adminAttendanceLoading' :class="{'fa fa-refresh': true, 'fa-spin': adminAttendanceLoading}"></i>-->
<!--                 </button>-->
<!--                <button type="button" :class="`btn ${attendanceStatus.status === 'shift in'? 'btn-success' : 'btn-danger'} btn-sm center left`" @click="clockInOut(attendanceStatus.status)" :disabled="disabled || isOnBreak">-->
<!--                   {{ attendanceStatus.status }}     <i v-if='adminAttendanceLoading' :class="{'fa fa-refresh': true, 'fa-spin': adminAttendanceLoading}"></i>-->
<!--                 </button>-->
<!--              </div>-->
<!--            </span>-->
<!--          </div>-->
<!--          <div class="card-body p-0 m-0 pr-0 mr-0 d-flex justify-content-end">-->
<!--            <div>-->
<!--              <div class="d-flex justify-content-center"><span class="time-font"><strong>{{ dateTime }}</strong> <small class="text-muted est-font"> (EST)</small> </span></div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="col-sm-12 col-md-2 col-lg-6">-->
<!--        <Monitors/>-->
<!--      </div>-->
<!--      <div class="col-sm-12 col-md-2 col-lg-6">-->
<!--        <ActiveTask/>-->
<!--      </div>-->
      <div class="col-md-12 col-lg-12 col-md-12 mb-20">
        <div v-if="chartLoading" class="card d-flex flex-column justify-content-center align-items-center" style="height: 600px;">
          <div class="loader"></div>
          <span class="fw-600">Loading Ticket Load Chart...</span>
        </div>
        <div v-show="!chartLoading" ref="chartContainer" style="width: 100%; height: 600px; border-radius: 12px"></div>
      </div>
      <div class="col-sm-4 col-md-4 col-lg-4">
        <Announcement/>
      </div>
<!--      <div class="col-sm-8 col-md-8 col-lg-8">-->
<!--        <RecentTicketComments/>-->
<!--      </div>-->
      <div class="col-sm-12 col-md-4 col-lg-4 mt-2">
        <RecentActivity/>
      </div>
      <div class="col-sm-12 col-md-4 col-lg-4 mt-2">
        <Todo/>
      </div>
<!--      <div class="col-sm-12 col-md-2 col-lg-6">-->
<!--        <watchList/>-->
<!--      </div>-->

    </div>
    <div class="reminder-modal position-relative">
      <div class="modal fade getBreakModal" id="getBreakModal" tabindex="-1" role="dialog" aria-labelledby="getBreakModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Add Break Time</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form action="" @submit.prevent="submit">
              <div class="modal-body">
                <div class="form-group">
                  <label>Expected time for break to end</label>
                  <select required class="form-control" v-model="formData.due_date">
                    <option v-for="value in breakOptions" :key=value.key :value=value.value >{{ value.key }}</option>
                  </select>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button :disabled="adminAttendanceLoading" class="btn btn-primary" >
                  <div v-if='adminAttendanceLoading' class="loader small_loader"></div>
                  <span v-else>Submit</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <staff-detail-modal ref="staffDetailModal"/>
  </div>
</template>

<script>
import Monitors from "@/components/Admin/AdminDashboard/Monitors.vue";
import Announcement from "@/components/Admin/AdminDashboard/Announcement.vue";
import {db} from "@/firebase/init";
import Todo from "@/components/Admin/AdminDashboard/Todo.vue";
import ActiveTask from "@/components/Admin/AdminDashboard/ActiveTask.vue";
import RecentActivity from "@/components/Admin/AdminDashboard/RecentActivity.vue";
import watchList from "@/components/Admin/AdminDashboard/watchList.vue";
import Chat from "@/components/Admin/AdminDashboard/Chat.vue";
import moment from "moment-timezone";
import md5 from "crypto-js/md5";
import RecentTicketComments from "@/components/Admin/AdminDashboard/RecentTicketComments";
import upcomingHeroMixin from "@/mixins/dashboard/upcomingHeroMixin";
import tippy from "tippy.js";
import 'tippy.js/dist/tippy.css';
import staffDetailModal from "@/components/Admin/AdminDashboard/modal/staffDetailModal.vue";
import swal from "sweetalert2";

export default {
  name: "dashboardUI",
  components: {staffDetailModal, RecentTicketComments, Announcement , Todo , ActiveTask , RecentActivity, watchList, Chat , Monitors},
  mixins:[upcomingHeroMixin],
  data () {
    return {
      attendanceLoading: false,
      gradientColors: [
        { stop: 0.0, color: "#2ecc40" },  // Not Busy
        { stop: 0.16, color: "#a3e635" }, // Slightly Busy
        { stop: 0.32, color: "#eab308" }, // Mildly Busy
        { stop: 0.48, color: "#f97316" }, // Moderate
        { stop: 0.64, color: "#ef4444" }, // Busy
        { stop: 0.80, color: "#b91c1c" }, // Very Busy
        { stop: 1.0, color: "#7f1d1d" }   // Extremely Busy
      ],
      clockEmoji: this.getClockEmoji(),
      categoryOneAdmins: [ { email: 'khan@bigscoots.com' },{ email: 'les@bigscoots.com' },{ email: 'justin@bigscoots.com' }, ],
      categoryThreeAdmins: [ { email: 'sara@bigscoots.com' },{ email: 'rao@bigscoots.com' }, ],
      categoryTwoAdmins: [ { email: 'katie@bigscoots.com' },{ email: 'sandy@bigscoots.com' }, ],
      breakOptions:[
        {key: '10 minutes', value: 10},
        {key: '15 minutes', value: 15},
        {key: '30 minutes', value: 30},
        {key: '1 hour', value: 60},
        {key: '1.5 hours', value: 90},
        {key: '2 hour', value: 120},
      ],
      dateTime: null,
      emergencyBreak: false,
      loading: false,
      attendanceStatus: {
        id: '',
        status: 'shift in',
        breaks:[],
      },
      isOnBreak: false,
      activeAdminListener: null,
      currentBreakTime:{
        startTime: '',
        endTime:'',
      },
      size: {
        type: Number,
        default: 100
      },
      activeAdmins: [],
      adminsOnBreak: [],
      disabled: false,
      adminAttendanceLoading: false,
      modeLoading: false,
      space: null,
      totalAdmins: [],
      secretEmails: ['sara@bigscoots.com', 'khan@bigscoots.com', 'scott@bigscoots.com', 'james@bigscoots.com', 'justin@bigscoots.com'],
      formData: {},
      firstPercentage: 100,
      secondPercentage: 100,
      todaysLeaves: [],
      ticketStats: {},
      monitorStats: {},
      prevWeekStats: {},
      department: '',
      listener: null,
      chartLoading: true,
      xCategories: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00',],
      chart: {
        type: 'bar'
      },
      title: {
        text: 'Monthly Ticket Stats'
      },
      xAxis: {
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
        title: {
          text: 'Month'
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Tickets',
          align: 'high'
        }
      },
      tooltip: {
        valueSuffix: ' tickets'
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true
          }
        }
      },
      series: [{
        name: 'Support Tickets',
        data: [120, 150, 180, 130, 160, 140]
      }],
      // chartDetails: {
      //   chart: {
      //     type: 'bar',
      //   },
      //   title: {
      //     text: 'Today’s Ticket Load',
      //   },
      //   tooltip: {
      //     formatter: function() {
      //       return 'Busy Factor: <b>' + this.y + '</b>';
      //     }
      //   },
      //   xAxis: {
      //     title: {
      //       text: 'Time (hours)' // ← Your x-axis name here
      //     },
      //     categories: this.xCategories,
      //   },
      //   credits: {
      //     enabled: false
      //   },
      //   legend: {
      //     enabled: false // ← This hides the legend
      //   },
      //   yAxis: {
      //     title: {
      //       text: 'Busy Factor',
      //     },
      //   },
      //   series: [{
      //     type: 'area',
      //     data: [],
      //     zones: [
      //       // { value: 1, color: '#FF5733' },  // Day 1
      //       // { value: 2, color: '#33FF57' },  // Day 2
      //       // { value: 3, color: '#3357FF' },  // Day 3
      //       // { value: 4, color: '#F7DC6F' },  // Day 4
      //       // { value: 5, color: '#AF7AC5' }   // Day 5+
      //       // {
      //       //   color: '#539BFF',
      //       //   fillColor: {
      //       //     linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
      //       //     stops: [
      //       //       [0, "rgba(83, 155, 255, 0.3)"],
      //       //       [1, "rgba(83, 155, 255, 0)"],
      //       //     ],
      //       //   },
      //       // }
      //     ],
      //     zoneAxis: 'x',
      //   }],
      // },
    }
  },
  mounted() {
    // this.getUpComingAdmins()
    this.getAllUserAttendance()
    this.fetchTicketStats();
    this.getUpcomingAdminsV2()// defined in mixin
    this.getLeaves()
    this.updateDateTime();
    this.timer = setInterval(() => {
      this.updateDateTime();
      $(function () {
        $('[data-toggle="tooltip"]').tooltip()
      })
    }, 1000);

  },
  computed: {
    getMyDepartment() {
      const obj  = this.activeAdmins.find(el => el.email === this.user.email)
      return obj ? obj.department : ''
    },
    upcomingAdmins(){
      return this.allUpComingAdmins.filter(el => !this.activeAdmins.find(activeAdmin => activeAdmin.email === el.email) || !!this.todaysLeaves.find(leave => leave.leaveType === 'partialLeave' && leave.email === el.email))
    },
    onEngMode(){
      return this.activeAdmins.filter(el => el.breaks && el.breaks.length && !el.breaks[el.breaks.length - 1].endTime && el.breaks[el.breaks.length - 1].type === 'engineering') || []
    },onPerfMode(){
      return this.activeAdmins.filter(el => el.breaks && el.breaks.length && !el.breaks[el.breaks.length - 1].endTime && el.breaks[el.breaks.length - 1].type === 'performance') || []
    },onMeetingMode(){
      return this.activeAdmins.filter(el => el.breaks && el.breaks.length && !el.breaks[el.breaks.length - 1].endTime && el.breaks[el.breaks.length - 1].type === 'meeting') || []
    },otherMode(){
      return this.activeAdmins.filter(el => el.breaks && el.breaks.length && !el.breaks[el.breaks.length - 1].endTime && (!el.breaks[el.breaks.length - 1].type || el.breaks[el.breaks.length - 1].type === 'other' || el.breaks[el.breaks.length - 1].type === 'offSupport')) || []
    },
    currentMode() {
      const breakObj = this.attendanceStatus.breaks ? this.attendanceStatus.breaks[this.attendanceStatus.breaks.length - 1] : {}
      return breakObj && !breakObj.endTime ? breakObj.type : 'active'
    },
    onBreak() {
      const breakObj = this.attendanceStatus.breaks ? this.attendanceStatus.breaks[this.attendanceStatus.breaks.length - 1] : {}
      return breakObj ? (!breakObj.type || breakObj.type === 'break') && !breakObj.endTime : false
    },
    supportOnLeave() {
      return this.todaysLeaves.filter(item => item.department === 'support')
    },
    salesOnLeave() {
      return this.todaysLeaves.filter(item => item.department === 'sales')
    },
    devsOnLeave() {
      return this.todaysLeaves.filter(item => item.department === 'development')
    },
    onDutySalesAdmins() {
      return this.activeAdmins.filter(el => el.status && ((el.breaks && el.breaks.length && el.breaks[el.breaks.length - 1].endTime) || el.breaks.length===0) && el.department && el.department === 'sales')
    },
    offDutyAdmins() {
      return this.activeAdmins.filter(el => el.breaks && el.breaks.length && !el.breaks[el.breaks.length - 1].endTime && (el.breaks[el.breaks.length - 1].type === 'meeting' ||el.breaks[el.breaks.length - 1].type === 'dev' ||el.breaks[el.breaks.length - 1].type === 'engineering' || el.breaks[el.breaks.length - 1].type === 'offSupport')) || []
    },
    onBreakAdmins() {
      return this.activeAdmins.filter(el => el.breaks && el.breaks.length && !el.breaks[el.breaks.length - 1].endTime) || []
    },
    onBreakSupportAdmins() {
      return this.activeAdmins.filter(el => el.breaks && el.breaks.length && !el.breaks[el.breaks.length - 1].endTime && el.department === 'support' && (!el.breaks[el.breaks.length - 1].type || el.breaks[el.breaks.length - 1].type === 'break')) || []
    },
    onBreakSalesAdmins() {
      return this.activeAdmins.filter(el => el.breaks && el.breaks.length && !el.breaks[el.breaks.length - 1].endTime && el.department === 'sales' && (!el.breaks[el.breaks.length - 1].type || el.breaks[el.breaks.length - 1].type === 'break')) || []
    },
    onBreakDevAdmins() {
      return this.activeAdmins.filter(el => el.breaks && el.breaks.length && !el.breaks[el.breaks.length - 1].endTime && el.department === 'development' && (!el.breaks[el.breaks.length - 1].type || el.breaks[el.breaks.length - 1].type === 'break')) || []
    },
    onDutyAdmins() {
      return this.activeAdmins.filter(el => el.status && ((el.breaks && el.breaks.length && el.breaks[el.breaks.length - 1].endTime) || el.breaks.length===0)  && el.department && el.department === 'support')
    },
    devAdmins() {
      return this.activeAdmins.filter(el => el.status && ((el.breaks && el.breaks.length && el.breaks[el.breaks.length - 1].endTime) || el.breaks.length===0)  && el.department && el.department === 'development')
    },
    upComingHeroes(){
      return this.upcomingAdmins.filter(admin => {
            return admin.department === 'support'
          }
      ).sort((a, b) => {
        return a.diffInMinutes - b.diffInMinutes
      })
    },
    upComingSalesHeroes(){
      return this.upcomingAdmins.filter(admin => {
            return admin.department === 'sales'
          }
      ).sort((a, b) => {
        return a.diffInMinutes - b.diffInMinutes
      })
    },upComingDevHeroes(){
      return this.upcomingAdmins.filter(admin => {
            return admin.department === 'development'
          }
      ).sort((a, b) => {
        return a.diffInMinutes - b.diffInMinutes
      })
    },
    getColumnClass(){
      console.log(this.getColForBreakAdmins , this.getColForUpcomingAdmins , 'these values')
      if(this.getColForBreakAdmins && this.getColForUpcomingAdmins ) {
        const onBreakCount = this.getColForBreakAdmins;
        const upcomingCount = this.getColForUpcomingAdmins;
        if (onBreakCount === 'col-md-2' && upcomingCount === 'col-md-2') {
          this.firstPercentage = 66;
          this.secondPercentage = 83.5;
          return 'col-md-8';
        } else if (onBreakCount === 'col-md-1' && upcomingCount === 'col-md-1') {
          this.firstPercentage = 50;
          this.secondPercentage = 72.5;
          return 'col-md-10';
        } else if (onBreakCount === 'col-md-2' || upcomingCount === 'col-md-2') {
          this.firstPercentage = 75;
          this.secondPercentage = upcomingCount === 'col-md-2' ? 82 : 90;
          return 'col-md-9';
        }
      }
      else if(this.getColForUpcomingAdmins  &&  this.getColForBreakAdmins === null ) {
        const result = this.getColForUpcomingAdmins === 'col-md-1' ? 'col-md-11' : 'col-md-10'
        this.firstPercentage = this.secondPercentage = result  === 'col-md-10' ? 80 : 90;
        return result;
      }
      else if(this.getColForUpcomingAdmins === null && this.getColForBreakAdmins) {
        const result = this.getColForBreakAdmins === 'col-md-1' ? 'col-md-11' : 'col-md-10'
        this.firstPercentage  = result  === 'col-md-10' ? 80 : 90;
        this.secondPercentage = 100
        return result
      }
      this.firstPercentage = 100;
      this.secondPercentage = 100;
      return 'col-md-12'
    },
    getColForUpcomingAdmins() {
      if(this.upComingHeroes && this.upComingHeroes.length > 0) {
        return this.upComingHeroes.length === 1 ? 'col-md-1' : 'col-md-2'
      }
      return null
    },
    getColForBreakAdmins() {
      if(this.onBreakAdmins && this.onBreakAdmins.length > 0) {
        return this.onBreakAdmins.length === 1 ? 'col-md-1' : 'col-md-2'
      }
      return null
    },
    user() {
      return this.$store.getters.user;
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.activeAdminListener();
    if(this.listener){
      this.listener()
    }
  },
  watch: {
    async ticketStats(val) {
      console.log('ticket stats', val);
      if(Object.keys(this.prevWeekStats).length === 0){
        await this.getPrevWeekStats()
      }
      this.initChart()
    },
    prevWeekStats(val) {
      this.initChart()
    }
  },
  methods: {
    openStaffDetails(data, time) {
      if(this.secretEmails.includes(this.user.email)) {
        const isLive = this.dateTime.split(':')[0] === time.split(':')[0] && data.date === moment().tz('America/New_York').format('YYYY-MM-DD');
        const currentMonitor = this.monitorStats;
        console.log('currentMonitor', currentMonitor);
        this.$refs.staffDetailModal.load({...data, time, isLive, currentMonitorObj: currentMonitor ? currentMonitor.hoursArray.find(el => el.time === time) : {}})
      }
    },
    getBreakText(row, type) {
      let title = '';
      if(type === 'break') {
        const lastObj = row.breaks[row.breaks.length - 1];
        const nextTime =  moment(lastObj.startTime).tz('America/New_York').add(lastObj.time, 'minutes').format('HH:mm');
        title = `${row.firstName} is on a ${lastObj.time}-minute break. Expected back at ${nextTime} EST.`
      } else if(type === 'leave') {
        if(row.leaveType === 'partialLeave') {
          title = `${row.firstName} is on ${row.leaveType === 'partialLeave' ? `partial leave from ${row.partialLeave.from} EST to ${row.partialLeave.to} EST` : 'leave'}`
        } else {
          const date = moment.tz(row.end, 'America/New_York').add(1, 'day').format('MMM DD, YYYY');
          const day = moment.tz(row.end, 'America/New_York').add(1, 'day').format('dddd');
          title = `${row.firstName} is on leave and will resume work on ${day}, ${date}.`
        }
      }
      return title
    },
    getInterpolatedColor(value, max) {
      console.log('at 861', value, max)
      const ratio = Math.max(0, Math.min(value / max, 1));
      let start, end;

      for (let i = 0; i < this.gradientColors.length - 1; i++) {
        if (ratio >= this.gradientColors[i].stop && ratio <= this.gradientColors[i + 1].stop) {
          start = this.gradientColors[i];
          end = this.gradientColors[i + 1];
          break;
        }
      }
      console.log('end at 871', end, start)
      if(!end || !start) return ''
      const range = end.stop - start.stop;
      const relativeRatio = (ratio - start.stop) / range;

      return this.interpolateColor(start.color, end.color, relativeRatio);
    },
    interpolateColor(color1, color2, factor) {
      const c1 = this.hexToRgb(color1);
      const c2 = this.hexToRgb(color2);
      const r = Math.round(c1.r + (c2.r - c1.r) * factor);
      const g = Math.round(c1.g + (c2.g - c1.g) * factor);
      const b = Math.round(c1.b + (c2.b - c1.b) * factor);
      return `rgb(${r},${g},${b})`;
    },
    hexToRgb(hex) {
      const parsed = hex.replace('#', '');
      return {
        r: parseInt(parsed.substring(0, 2), 16),
        g: parseInt(parsed.substring(2, 4), 16),
        b: parseInt(parsed.substring(4, 6), 16),
      };
    },
    calculateBusyCoefficient(obj, date) {
      if(!date) {
        date = moment().tz('America/New_York').format('YYYY-MM-DD');
      }
      if(!obj) {
        obj = {
          availableCount: 1,
          total_tickets_handled: 0,
          total_responses: 0
        }
      }
      let availableCount = obj ? obj.availableCount : 1
      let monitors = 0
      if(date) {
        monitors = this.getMonitorCount(date, obj.time)
      }
      return Number(((obj.total_tickets_handled+obj.total_responses+ monitors)/Number(availableCount)).toFixed(2))
    },
    getMonitorCount(date, time) {
      let monitors = 0
      const objMonitor = this.monitorStats;
      console.log('monitor obj', objMonitor)
      if(objMonitor && objMonitor.hoursArray) {
        const required = objMonitor.hoursArray.find(el => el.time === time)
        if(required && required.staff) {
          console.log('required staff', required)
          monitors = required.staff.reduce((sum, record) => sum + record.count, 0);
        }
      }
      return monitors
    },
    initChart() {
      const categories = JSON.parse(JSON.stringify(this.xCategories))
      const currentTime = `${moment().tz('America/New_York').format('HH')}:00`

      const index = categories.findIndex(el => el === currentTime)

      if (index !== -1) {
        categories[index] = `<span style="color:green; font-weight:bold;">🟢 LIVE</span>`
      }
      console.log('categories', categories)
      const vm = this;
      const barChart = {
        chart: {
          type: 'column'
        },
        title: {
          text: `Daily Load Stats (${moment().tz('America/New_York').format('MMM DD, YYYY')})`
        },
        xAxis: {
          categories,
          title: {
            text: 'Time'
          }
        },
        yAxis: {
          min: 0,
              title: {
            text: 'Busy Factor',
                align: 'high'
          }
        },
        tooltip: {
          formatter: function() {
            console.log('vm', vm, this.x)
            let obj = null;
            if(this.x > vm.dateTime.split(':')[0]) {
              obj = vm.prevWeekStats.hoursArray.find(el => el.time.split(':')[0] == this.x);
            } else if(this.x == vm.dateTime.split(':')[0]) {
              obj = vm.ticketStats.last15Min
            } else {
              obj = vm.ticketStats.hoursArray.find(el => el.time.split(':')[0] == this.x);
            }
            console.log('tooltip', obj)
            return `Total Tickets Handled: <b>${obj ? obj.total_tickets_handled: 0}</b><br>Total Responses: <b>${obj ? obj.total_responses: 0}</b><br>Total Monitors: <b>${obj ? vm.getMonitorCount('', this.x+':00'): 0}</b><br>Available Staff: <b>${obj ? `${obj.availableCount.toFixed(2)}/${obj.availableStaff.length}`: ''}</b><br>Busy Factor: <b>${obj ? vm.calculateBusyCoefficient(obj) : 0}</b>`;
          }
        },
        plotOptions: {
          series: {
            cursor: 'pointer',
            point: {
              events: {
                click: function () {
                  vm.openStaffDetails(vm.ticketStats, `${this.category.includes('LIVE') ? `${vm.dateTime.split(':')[0]}:00` : this.category}`)
                }
              }
            }
          },
          bar: {
            dataLabels: {
              enabled: true
            }
          }
        },
        legend: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        series: [{
          data: []
        }]
      }
      if (this.ticketStats.hoursArray) {
        if (!this.ticketStats.maxBusyFactor || this.ticketStats.maxBusyFactor === 0) {
          this.ticketStats.maxBusyFactor = Math.max(
              ...this.ticketStats.hoursArray.map(item =>
                  item.time <= this.dateTime
                      ? this.calculateBusyCoefficient(item)
                      : this.calculateBusyCoefficient(
                          this.prevWeekStats.hoursArray.find(el => el.time === item.time)
                      )
              )
          );
        }

        // this.chartDetails.series[0].data = [];
        // this.chartDetails.series[0].zones = [];

        for (const [i, row] of this.ticketStats.hoursArray.entries()) {
          if(row.time <= this.dateTime){
            const isCurrentTime = row.time.split(':')[0] === this.dateTime.split(':')[0]
            const busyFactor = this.calculateBusyCoefficient(isCurrentTime ? this.ticketStats.last15Min : row)
            barChart.series[0].data.push({y: busyFactor, color: isCurrentTime ? '#000' : this.getInterpolatedColor(busyFactor, this.ticketStats.maxBusyFactor)});
          } else {
            if(this.prevWeekStats.hoursArray.length > 0) {
              const obj = this.prevWeekStats.hoursArray.find(el => el.time === row.time);
              if(obj) {
                const busyFactor = this.calculateBusyCoefficient(obj)
                barChart.series[0].data.push({y: busyFactor, color: '#d2d2d2'});
              }
            }
          }

        }

        console.log('series data', barChart.series[0].data);

        Highcharts.setOptions({
          time: {
            timezone: 'America/New_York'
          }
        });

        Highcharts.chart(this.$refs.chartContainer, { ...barChart }, () => {
          console.log('Chart loaded from callback');
          this.chartLoading = false;
        });
      }
    },
    async fetchTicketStats() {
      this.ticketStats = {}
      this.listener = await db.collection('dashboardStats').where('date', '==', moment().tz('America/New_York').format('YYYY-MM-DD')).onSnapshot(querySnapshot => {
        querySnapshot.docChanges().forEach(changeDoc => {
          const {type} = changeDoc.doc.data()
          if (changeDoc.type === 'added'){
            if(type === 'ticket') {
              this.ticketStats = ({id: changeDoc.doc.id, ...changeDoc.doc.data()})
            } else if(type === 'monitor') {
              this.monitorStats = ({id: changeDoc.doc.id, ...changeDoc.doc.data()})
            }
          }
          if(changeDoc.type === 'modified') {
            console.log('modified')
            if(type === 'ticket') {
              this.ticketStats = ({id: changeDoc.doc.id, ...changeDoc.doc.data()})
            } else if(type === 'monitor') {
              this.monitorStats = ({id: changeDoc.doc.id, ...changeDoc.doc.data()})
            }
          }
          if(changeDoc.type === 'removed') {
            this.ticketStats = {}
            this.monitorStats = {}
          }
        });
      });
    },
    async getPrevWeekStats() {
      const prevWeekDate = moment().tz('America/Chicago').subtract(1, 'week').format('YYYY-MM-DD');
      console.log('prevWeekDate', prevWeekDate);
      const prevWeekRef = await db.collection('dashboardStats').where('type', '==', 'ticket').where('date', '==', prevWeekDate).limit(1).get();
      if(prevWeekRef.size) {
        this.prevWeekStats = {id: prevWeekRef.docs[0].id, ...prevWeekRef.docs[0].data()};
      }
    },
    formatTime(date) {
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${hours}:${minutes}`
    },
    getClockEmoji() {
      const hour = Number(moment().tz('America/New_York').format('hh')) % 12 || 12
      const half = Number(moment().tz('America/New_York').format('mm')) >= 30 ? '30' : '00'
      // console.log('hours', hour, half)
      const emojiMap = {
        '1-00': '🕐', '1-30': '🕜',
        '2-00': '🕑', '2-30': '🕝',
        '3-00': '🕒', '3-30': '🕞',
        '4-00': '🕓', '4-30': '🕟',
        '5-00': '🕔', '5-30': '🕠',
        '6-00': '🕕', '6-30': '🕡',
        '7-00': '🕖', '7-30': '🕢',
        '8-00': '🕗', '8-30': '🕣',
        '9-00': '🕘', '9-30': '🕤',
        '10-00': '🕙', '10-30': '🕥',
        '11-00': '🕚', '11-30': '🕦',
        '12-00': '🕛', '12-30': '🕧',
      };
      return emojiMap[`${hour}-${half}`] || '🕰️'
    },
    getWidth(array) {
      if(array.length >= 3) return 'width: 80%'
      else if(array.length >= 1) return 'width: 90%'
      else if(array.length === 0) return 'width: 100%'
    },
    getWidths() {
      const onDuty = this.onDutyAdmins.length;
      const upcoming = this.upComingHeroes.length;
      const total = onDuty + upcoming || 1; // prevent divide-by-zero
      const onDutyWidth = `${(onDuty / total) * 100}%`;
      const upcomingWidth = `${(upcoming / total) * 100}%`;
      return { onDutyWidth, upcomingWidth };
    },
    async getLeaves(){
      try{
        const fullLeaveRef = await db.collection('leaveRecords').where('status', '==', 'approved').where('leaveDays', 'array-contains', moment().tz('America/New_York').format('YYYY-MM-DD')).get();
        if(fullLeaveRef.size) {
          fullLeaveRef.forEach(async (doc) => {
            const data = doc.data()
            const ref = await db.collection('users').where('email', '==',data.email).limit(1).get();
            if(ref.size) {
              data.department = ref.docs[0].data().department;
            }
            this.todaysLeaves.push({id: doc.id, ...data});
          })
        }
        const partialLeave = await db.collection('leaveRecords').where('status', '==', 'approved').where('partialLeave.date', '==', moment().tz('America/New_York').format('YYYY-MM-DD')).get();
        if(partialLeave.size) {
          partialLeave.forEach(async (doc) => {
            const data = doc.data()
            const ref = await db.collection('users').where('email', '==',data.email).limit(1).get();
            if(ref.size) {
              data.department = ref.docs[0].data().department;
            }
            this.todaysLeaves.push({id: doc.id, ...data});
          })
        }
      } catch (e) {
        console.log('something wrong happened when fetching todays leave', e.toString());
      }
    },
    getTitle(flag, title, id) {
      if(!flag) {
        return true
      }
      tippy(`#${id}`, {
        content: title,
        allowHTML: true,
        theme: 'dark', // Customize the theme in your CSS if needed
        placement: 'top'
      });
    },
    async endBreak(){
      try{
        this.currentBreakTime.endTime = new Date().toISOString();
        this.attendanceStatus.breaks[this.attendanceStatus.breaks.length-1].endTime= this.currentBreakTime.endTime;
        await db.collection('attendance').doc(this.attendanceStatus.id).update({
          breaks: this.attendanceStatus.breaks
        })
        const blocks = [
          {
            "type": "context",
            "elements": [
              {
                "type": "plain_text",
                "text": `:technologist: ${this.user.firstName} ${this.user.lastName} is back to active mode and ready to assist!`,
                "emoji": true
              }
            ]
          }
        ]
        await this.$http.post('/slack/send_slack_message', {
          blocks,
          type: 'teamchat',
          grant_type: 'token'
        })
      }
      catch(e){
        console.log(e.toString(), 'Error Occurred in ending break')
      }
      finally {
        // this.isOnBreak = false;
      }
    },
    // checkBreakExist(){
    //   if(this.attendanceStatus.breaks.length === 0 ){
    //     this.isOnBreak  = false;
    //     return
    //   }
    //   const result =this.attendanceStatus.breaks.find((value)=>  value.startTime && value.endTime === '')
    //   if(result=== undefined){
    //     this.isOnBreak= false;
    //     return
    //   }
    //   this.isOnBreak=true;
    //   this.attendanceStatus.startTime=result.startTime;
    // },
    async submit(){
      try{
        if(this.getMyDepartment === 'support') {
          console.log('on duty admins', this.onDutyAdmins.map(el => el.email), this.onBreakSupportAdmins.map(el => el.email))
          const currentlyActiveAdmins = this.onDutyAdmins.map(el => el.email)
          const currentlyBreakAdmins = this.onBreakSupportAdmins.map(el => el.email)
          if(currentlyActiveAdmins.length > 4) {
            const thirtyPercentCount = Math.ceil(currentlyActiveAdmins.length * 0.3);
            console.log(thirtyPercentCount)
            if(currentlyBreakAdmins.length >= thirtyPercentCount) {
              const resp = await swal.fire({
                width: '700px',
                icon: 'question',
                title: '🛎️ Support Desk Break Advisory',
                html: `
    <p>
     Some support admins are currently on break.
      ⏳ Taking a break at this time might impact support desk coverage.<br/>
       If your issue is urgent, you may initiate an emergency break.🚨
      Otherwise, please consider waiting until additional admins return to
      ensure smooth support operations.
    </p>
  `,
                showCancelButton: true,
                confirmButtonText: '🚨 Emergency Break',
                cancelButtonText: '⏳ Wait While Others Return',
                confirmButtonColor: '#6FCF97',
                cancelButtonColor: '#F28B5B',
              });
              console.log('resp of swql', resp)
              if (!resp.value || resp.dismiss === 'cancel') {
                await db.collection('missedBreaks').add({
                  createdAt: new Date().toISOString(),
                  email: this.user.email,
                  currentlyActiveAdmins,
                  uid: this.user.uid,
                  date: moment().format('YYYY-MM-DD'),
                  currentlyBreakAdmins
                })
                $('#getBreakModal').modal('hide');
                return
              } else {
                this.emergencyBreak = true
              }
            }
          }
          else {
            if(currentlyBreakAdmins.length >= 1) {
              const resp = await swal.fire({
                width: '700px',
                icon: 'question',
                title: '🛎️ Support Desk Break Advisory',
                html: `
    <p>
     Some support admins are currently on break.
      ⏳ Taking a break at this time might impact support desk coverage.<br/>
       If your issue is urgent, you may initiate an emergency break.🚨
      Otherwise, please consider waiting until additional admins return to
      ensure smooth support operations.
    </p>
  `,
                showCancelButton: true,
                confirmButtonText: '🚨 Emergency Break',
                cancelButtonText: '⏳ Wait While Others Return',
                confirmButtonColor: '#6FCF97',
                cancelButtonColor: '#F28B5B',
              });
              if (!resp.value || resp.dismiss === 'cancel') {
                await db.collection('missedBreaks').add({
                  createdAt: new Date().toISOString(),
                  email: this.user.email,
                  currentlyActiveAdmins,
                  uid: this.user.uid,
                  date: moment().format('YYYY-MM-DD'),
                  currentlyBreakAdmins
                })
                $('#getBreakModal').modal('hide');
                return
              } else {
                this.emergencyBreak = true
              }
            }
          }
        }
        let now = new Date();
        // now.setMinutes(now.getMinutes() + this.formData.due_date);
        // const localTime = now.toISOString();
        this.adminAttendanceLoading=true;
        if(this.attendanceStatus.breaks.length > 0 && !this.attendanceStatus.breaks[this.attendanceStatus.breaks.length-1].endTime){
          this.attendanceStatus.breaks[this.attendanceStatus.breaks.length-1].endTime = new Date().toISOString()
        }
        this.currentBreakTime.startTime =new Date().toISOString()
        this.currentBreakTime.time = this.formData.due_date
        this.currentBreakTime.endTime='';
        this.currentBreakTime.type='break';
        if(this.emergencyBreak) {
          this.currentBreakTime.emergencyBreak = true
        }
        this.attendanceStatus.breaks.push({...this.currentBreakTime});
        await db.collection('attendance').doc(this.attendanceStatus.id).update({
          breaks: this.attendanceStatus.breaks
        })
        const easternTime = now.toLocaleString('en-US', {
          timeZone: 'America/New_York',
        });
        let finalDate = moment(easternTime).format("MMMM Do YYYY, h:mm a")
        const text = this.emergencyBreak ? `:coffee: ${this.user.firstName} ${this.user.lastName} is aware too many people are away, but it's an urgent. Back in ${this.formData.due_date} minutes.` : `:coffee: ${this.user.firstName} ${this.user.lastName} is on break for next ${this.formData.due_date} minutes. Please hold tight!`
        const blocks = [
          {
            "type": "context",
            "elements": [
              {
                "type": "plain_text",
                "text": text,
                "emoji": true
              }
            ]
          }
        ]
        await this.$http.post('/slack/send_slack_message', {
          blocks,
          type: 'teamchat',
          grant_type: 'token'
        })
        this.isOnBreak = true
        $('#getBreakModal').modal('hide');
      }
      catch (e){
        console.log(e.toString(), 'Error occurred in adding start time')
      }
      finally {
        this.adminAttendanceLoading=false;
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
        // this.checkBreakExist()
      }
    },
    async mode(type){
      try{
        const blocks = []
        this.modeLoading=true;
        if(type === 'other' || type === 'performance' || type === 'meeting' || type === 'engineering') {
          if(this.attendanceStatus.breaks && this.attendanceStatus.breaks.length > 0 && !this.attendanceStatus.breaks[this.attendanceStatus.breaks.length-1].endTime){
            this.attendanceStatus.breaks[this.attendanceStatus.breaks.length-1].endTime = new Date().toISOString()
          }
          this.attendanceStatus.breaks.push({
            startTime: new Date().toISOString(),
            endTime: '',
            type,
          });
          await db.collection('attendance').doc(this.attendanceStatus.id).update({
            breaks: this.attendanceStatus.breaks
          })
          let text = '';
          if(type === 'meeting') {
            text = `:headphones: ${this.user.firstName} ${this.user.lastName} has switched to ${type} mode.`
          } else if(type === 'engineering') {
            text = `:bob_the_builder: ${this.user.firstName} ${this.user.lastName} has switched to ${type} mode.`
          } else if(type === 'performance') {
            text = `:zap: ${this.user.firstName} ${this.user.lastName} has switched to ${type} mode.`
          } else if(type === 'other') {
            text = `:wrench: ${this.user.firstName} ${this.user.lastName} has switched to ${type} mode to focus on other tasks.`
          }
          blocks.push({
            "type": "context",
            "elements": [
              {
                "type": "plain_text",
                "text": text,
                "emoji": true
              }
            ]
          })
        }else if(type === 'active') {
          if(this.attendanceStatus.breaks && this.attendanceStatus.breaks.length > 0 && !this.attendanceStatus.breaks[this.attendanceStatus.breaks.length-1].endTime){
            this.attendanceStatus.breaks[this.attendanceStatus.breaks.length-1].endTime = new Date().toISOString()
          }
          await db.collection('attendance').doc(this.attendanceStatus.id).update({
            breaks: this.attendanceStatus.breaks
          })
          blocks.push({
            "type": "context",
            "elements": [
              {
                "type": "plain_text",
                "text": `:technologist: ${this.user.firstName} ${this.user.lastName} is back to active mode and ready to assist!`,
                "emoji": true
              }
            ]
          })
        }
        await this.$http.post('/slack/send_slack_message', {
          blocks,
          type: 'teamchat',
          grant_type: 'token'
        })
      }
      catch (e){
        console.log(e.toString(), 'Error occurred in adding start time')
      }
      finally {
        this.modeLoading=false;
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
      }
    },
    fixModal() {
      console.log('fix modal')
      /* eslint-disable */
      this.loading=false
      this.formData={}
      this.formData.due_date= 10
      $('#getBreakModal').modal('show');
      $('.modal-backdrop').removeClass("getBreakModal");

    },
    emailHashGravatar(email) {
      if (!email) {
        return null
      } else {
        return md5(email.trim().toLowerCase()).toString()
      }
    },
    setCheckinStatus(id, data , isOnBreak , isLogOut = false ){
      if(isLogOut){
        this.attendanceStatus.status= 'shift in'
        this.adminAttendanceLoading =false
        return
      }
      if(isOnBreak){
        this.attendanceStatus.breaks = data.breaks;
        this.isOnBreak = true
        return
      }

      this.isOnBreak= false;
      this.attendanceStatus.breaks = data.breaks;
      return
    },
    async getAllUserAttendance(){
      try{
        console.log('aten', this.attendanceLoading)
        this.attendanceLoading = true
        const ref= db.collection('attendance')
        this.activeAdminListener = await ref.onSnapshot(async querySnapshot => {
          const promises = querySnapshot.docChanges().map(async changeDoc => {
            if (changeDoc.type === 'added'){
              if(changeDoc.doc.data().status){
                const data = changeDoc.doc.data()
                const ref = await db.collection('users').where('email', '==', data.email).limit(1).get();
                if(ref.size) {
                  data.department = ref.docs[0].data().department || '';
                }
                this.activeAdmins.push({id: changeDoc.doc.id , ...data})
                if(changeDoc.doc.data().userUid === this.user.uid){
                  this.attendanceStatus.id= changeDoc.doc.id
                  this.attendanceStatus.status= 'shift out'
                  this.attendanceStatus.breaks =  changeDoc.doc.data().breaks === undefined ? []: changeDoc.doc.data().breaks;
                  if (this.attendanceStatus.breaks && this.attendanceStatus.breaks.length) {
                    const lastObj = this.attendanceStatus.breaks[this.attendanceStatus.breaks.length - 1]
                    this.isOnBreak = !lastObj.endTime && (!lastObj.type || lastObj.type === 'break')? true : false;
                  }
                  this.adminAttendanceLoading = false
                }
              }
            }
            else if(changeDoc.type === 'modified') {
              let data = changeDoc.doc.data();
              // this means shift out
              const obj = this.activeAdmins.find(el => el.id === changeDoc.doc.id);
              if (obj) {
                obj.breaks = data.breaks
              }
              if (data.status === false && data.checkOutTime) {
                this.activeAdmins = this.activeAdmins.filter((value) => value.id !== changeDoc.doc.id)
                // this.adminsOnBreak= this.adminsOnBreak.filter((value)=>value.id !== changeDoc.doc.id)
                // this.totalAdmins= this.totalAdmins.filter((value)=>value.id !== changeDoc.doc.id)

                if (data.userUid === this.user.uid) {
                  console.log('I got called while log out');
                  this.setCheckinStatus(changeDoc.doc.id, data, false, true)
                }
              }
              // this means change is about break end
              else if (data.breaks.length > 0 && data.breaks[data.breaks.length - 1].endTime) {
                // this.adminsOnBreak= this.adminsOnBreak.filter((value)=>value.id !== changeDoc.doc.id)
                // this.activeAdmins.push({id: changeDoc.doc.id , ...changeDoc.doc.data()})

                if (data.userUid === this.user.uid) {
                  this.setCheckinStatus(changeDoc.doc.id, data, false)
                }
              }
              // this means break starts
              else if (data.breaks.length > 0 && !data.breaks[data.breaks.length - 1].endTime) {
                // this.adminsOnBreak.push({id: changeDoc.doc.id , ...changeDoc.doc.data()})
                // this.activeAdmins= this.activeAdmins.filter((value)=>value.id !== changeDoc.doc.id)
                if (data.userUid === this.user.uid) {
                  this.setCheckinStatus(changeDoc.doc.id, data, true)
                }
              } else if(!data.status) {
                this.activeAdmins = this.activeAdmins.filter((value) => value.id !== changeDoc.doc.id)
              }
            }
            // console.log('active admins', this.activeAdmins)
            $(function () {
              $('[data-toggle="tooltip"]').tooltip()
            })
          })
          await Promise.all(promises);
          this.attendanceLoading = false
        });
      }
      catch(e){
        console.log(e.toString(), 'Error in fetching all admins attendance')
      }
      finally {
      }

    },
    async clockInOut(value){
      this.disabled= true;
      this.adminAttendanceLoading=true;
      try{
        let blocks = [];
        if(value==='shift in'){
          const alreadyLoggedRef = await db.collection('attendance').where('email', '==', this.user.email).where('status', '==', true).get();
          if(alreadyLoggedRef.size) {
            for(const doc of alreadyLoggedRef.docs) {
              await db.collection('attendance').doc(doc.id).update({status: false, checkOutTime: new Date().toISOString()})
            }
          }
          const ref= await db.collection('attendance').add({
            firstName: this.user.firstName,
            lastName: this.user.lastName,
            email: this.user.email,
            userUid: this.user.uid,
            checkInTime: new Date().toISOString(),
            createdAt: new Date().toISOString(),
            breaks: [],
            status: true,
          })
          blocks = [
            {
              "type": "context",
              "elements": [
                {
                  "type": "plain_text",
                  "text": `:bell: ${this.user.firstName} ${this.user.lastName} has clocked in and is now available to assist!`,
                  "emoji": true
                }
              ]
            }
          ]
          await this.$http.post('/slack/send_slack_message', {
            blocks,
            type: 'teamchat',
            grant_type: 'token'
          })
          this.$http.post('/utilities/update-availability-status', {
            grant_type: "token",
            event: 'shift_in',
          })
          this.attendanceStatus.id =ref.id;
          this.attendanceStatus.status='shift out'
        }
        else {
          await db.collection('attendance').doc(this.attendanceStatus.id).update({
            checkOutTime: new Date().toISOString(),
            status: false,
          })
          blocks = [
            {
              "type": "context",
              "elements": [
                {
                  "type": "plain_text",
                  "text": `:alarm_clock: ${this.user.firstName} ${this.user.lastName} has clocked out for the day.`,
                  "emoji": true
                }
              ]
            }
          ]
          await this.$http.post('/slack/send_slack_message', {
            blocks,
            type: 'teamchat',
            grant_type: 'token'
          })
          this.$http.post('/utilities/update-availability-status', {
            grant_type: "token",
            event: 'shift_out',
          })
          this.attendanceStatus.status= 'shift in'
        }
      }
      catch(e){
        console.log(e.toString(), `Error in ${value} attendance`)
      }
      finally {
        this.disabled=false;
        this.isOnBreak = false;
        // this.checkBreakExist()
        this.adminAttendanceLoading=false;
      }
    },
    updateDateTime(){
      let now = new Date();
      const easternTime = now.toLocaleString('en-US', {
        timeZone: 'America/New_York',
      });
      let finalDate=moment(easternTime).format("HH:mm")
      this.clockEmoji = this.getClockEmoji()
      this.dateTime=finalDate;
    }
  }

};
</script>

<style scoped>
.hero-heading{
  padding: 0;
  margin: 0;
  //text-transform: capitalize;
}
.top-cards{
  border-radius: 40px;
}
.adminImage{
  border-radius: 50%;
  margin: 0px 3px 0px 3px;
  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.2)
}
.image-container img {
  width: 15%;
}
.time-font{
  font-size : 35px;
  font-family: 'Orbitron';
}
.est-font{
  font-size: 15px
}
.clock-display {
  font-size: 2rem;
  font-family: 'Courier New', monospace;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  color: #1f2937;
}
.emoji {
  font-size: 2.2rem;
}
.grayscale{
  filter: grayscale(1);
}
.flex-direction-row{
  flex-direction: row;
}
</style>
